import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { AddDocAccess, EditDocAccess } from './document-access-types.interface';

@Injectable({
    providedIn: 'root'
})
export class DocumentAccessTypesService {
    private token!: string;
    private basePath = environment.interop.basePath;

    private listUrl =
        this.basePath +
        environment.interop.indoc.nomenclatoare.registratura.categorii.list;

    public listDTUrl =
        this.basePath +
        environment.interop.indoc.nomenclatoare.registratura.categorii.listDT;

    private findURL =
        this.basePath +
        environment.interop.indoc.nomenclatoare.registratura.categorii.find;

    private storeURL =
        this.basePath +
        environment.interop.indoc.nomenclatoare.registratura.categorii.store;

    private updateUrl =
        this.basePath +
        environment.interop.indoc.nomenclatoare.registratura.categorii.update;

    private deleteUrl =
        this.basePath +
        environment.interop.indoc.nomenclatoare.registratura.categorii.delete;

    private listActiveUrl =
        this.basePath +
        environment.interop.indoc.nomenclatoare.registratura.categorii
            .listActive;

    private listPublicUrl =
        this.basePath +
        environment.interop.indoc.nomenclatoare.registratura.categorii
            .listPublic;

    private changeStatusActiveUrl =
        this.basePath +
        environment.interop.indoc.nomenclatoare.registratura.categorii
            .active;

    private changeStatusPublicUrl =
        this.basePath +
        environment.interop.indoc.nomenclatoare.registratura.categorii
            .public;

    private httpOptions: any;

    constructor(private http: HttpClient) { }

    getListDT() {
        return this.http.get(this.listDTUrl, this.httpOptions);
    }

    findEntry(id: number) {
        return this.http.post(this.findURL + id, this.httpOptions);
    }

    storeEntry(payload: AddDocAccess) {
        return this.http.post(this.storeURL, payload, this.httpOptions);
    }

    updateEntry(payload: EditDocAccess) {
        return this.http.put(this.updateUrl, payload, this.httpOptions);
    }

    deleteEntry(id: number) {
        return this.http.delete(this.deleteUrl + id, this.httpOptions);
    }

    getListActive() {
        return this.http.get(this.listActiveUrl, this.httpOptions);
    }

    getListPublic() {
        return this.http.get(this.listPublicUrl, this.httpOptions);
    }

    changeStatusActive(id: number) {
        return this.http.put(this.changeStatusActiveUrl + id, {}, this.httpOptions);
    }

    changeStatusPublic(id: number) {
        return this.http.put(this.changeStatusPublicUrl + id, {}, this.httpOptions);
    }

    setToken(token: string) {
        this.token = token;
        this.httpOptions = {
            headers: new HttpHeaders({
                'Content-Type': 'application/json',
                Accept: 'application/json',
                Authorization: `Bearer ${this.token}`,
            }),
        };
    }
}
